// extracted by mini-css-extract-plugin
module.exports = {"Container":"Backdrop_Container__1cWYe","Hidden":"Backdrop_Hidden__MWBI_"};